import { message } from 'antd'
import DocumentsApi from '../../../../api/Documents'
import AddRequisitions from '../../../../components/Corporate/Requisitions/AddRequisitions/AddRequisitions'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import useModalData from '../../../../elements/Hooks/useModalData'
import useSubmit from '../../../../elements/Hooks/useSubmit'
import useTitle from '../../../../elements/Hooks/useTitle'
import _, { get, isEmpty, pick } from 'lodash'
import qs from 'query-string'
import React from 'react'
import { RequisitionsApi } from '../../../../api/Corporates/Requisitions'

const docsApi = new DocumentsApi()

function AddRequisitionsCont(props) {
  const key = _.get(props.match, 'params.key')
  const values = qs.parse(props.location.search)
  const saleOrderID = values.saleOrderID

  const isNew = !key

  const {
    object: requisition,
    setObject: setRequisition,
    submitting,
    fetching,
    fetchObject: fetch,
    submit,
    removing,
    remove,
    formRef,
    update,
  } = useModalData(
    RequisitionsApi.create,
    RequisitionsApi.update,
    RequisitionsApi.remove,
    undefined,
    key,
    RequisitionsApi.read,
    (key) => {
      props.history.replace({
        pathname: `/purchasing/requisitions/${key}/update`,
      })
    },
    () => {
      props.history.replace({
        pathname: `/purchasing/requisitions/`,
      })
    }
  )

  React.useEffect(() => {
    if (!isNew) {
      setRequisition(requisition)
    }
  }, [requisition])

  const { list: actions, fetching: fetchingActions, fetch: fetchActions } = useFetchList(
    () => docsApi.actions('requisitions', requisition.status),
    [requisition.status, isEmpty(requisition.status)]
  )
  const [submittingOperation, submitOperation] = useSubmit(RequisitionsApi.operation)

  async function handleActions(operation) {
    let hide = message.loading('', 0)
    switch (operation) {
      default:
        const reqsDB = await submitOperation(operation, pick(requisition, ['_key', '_rev', '_id']))
        if (reqsDB) {
          setRequisition(reqsDB)
          await fetch()
        }
        break
    }
    hide()
  }

  const isUpdatable = actions.find((a) => a.key === 'update')
  const isRemovable = actions.find((a) => a.key === 'remove') || false
  useTitle(`Requisitions : ${_.get(requisition, 'code')}`)

  return (
    <AddRequisitions
      {...{
        isNew,
        requisition,
        fetching,
        submitting,
        actions,
        fetchingActions,
        fetchActions,
        handleActions,
        isUpdatable,
        isRemovable,
        fetch,
        submit,
        removing,
        remove,
        update,
        formRef,
        saleOrderID,
      }}
    />
  )
}

export default AddRequisitionsCont
